import CatalogueMainPromotions from "./components/CatalogueMainPromotions";
import { PromotionsProps } from "./promotions.type";
import styles from "./promotions.module.css";

const Promotions = ({ promotions }: PromotionsProps) => {
  return (
    <div className={styles.wrapperCataloguePromotions}>
      <CatalogueMainPromotions promotions={promotions} />
    </div>);

};

export default Promotions;